export default __webpack_public_path__ + "static/media/captureImg.0b1d380b.svg";